import styled from 'styled-components';

export const SubPanelSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    padding: 0;
  }

  .BaseSelect__control {
    height: 34px;
    display: flex;
    align-content: center;
    font-size: 14px;
  }

  .BaseSelect__indicators {
    display: flex;
    height: 34px;
  }

  .BaseSelect__indicator {
    width: 14px;
    height: 20px;
    color: black;
    padding: 0;
  }

  .BaseSelect__value-container {
    margin: auto;
    padding-left: 2px;
  }

  .BaseSelect__menu {
    font-size: 12px;
  }

  .BaseSelect__option {
    height: 18px;
    padding: 2px;
  }
}

  #current_retailers_failing_number {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  button {
    height: 34px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DatePanelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  #inspection_failure_rate_by-locations {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

  .BaseSelect__control {
    width: 130px;
  }
}
`;

export const SubPanelLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

export const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};

  &:focus {
    outline: none;
    border-color: #ef4444;
    box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.2);
  }
`;

export const Select = styled.select`
  width: ${({ width }) => width || '150px'};
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  height: 24px;
  font-size: 14px;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #ef4444;
    box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.2);
  }
`;

export const DateRangeContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const DateRangeSeparator = styled.span`
  color: #6b7280;
  font-size: 14px;
`;

export const ScoreRangeContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ScoreInput = styled(Input)`
  flex: 1;
`;

export const PickerWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-width: 500;

  button {
    top: 2px;
    height: 36px;
  }

  .custom-react-date-picker {
    width: 145px;
  }

  .react-datepicker {
    width: auto;
    padding: 35px 25px 15px;
  }

  .react-datepicker__header__dropdown {
    top: -25px;
  }

  .react-datepicker__navigation--previous {
    right: 50px;
    top: 15px;
  }

  .react-datepicker__navigation--next {
    right: 35px;
    top: 15px;
  }

  .react-datepicker__month-container {
    width: 250px;
    height: 210px;
  }
`;

export const SwatchLegendSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

export const SwatchLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;
